import React from 'react';

import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';

import { FormattedMessage } from '@futrli/localisation';

import { trackHelpMenuEvent, TRACK_ASK_QUESTION, TRACK_HELP_CENTRE } from './help-tracker';

import * as styles from './help-list.scss';
import { ZEN_DESK_URL } from '../../core/constants';

export const HelpList = () => {
  /**
   * Triggers the intercom menu click tracking and closing
   */
  const handleIntercomMenuClick = () => {
    trackHelpMenuEvent(TRACK_ASK_QUESTION);
  };

  /**
   * Triggers the help centre menu click tracking and closing
   */
  const handleHelpCentreMenuClick = () => {
    trackHelpMenuEvent(TRACK_HELP_CENTRE);
  };

  return (
    <div>
      <Box display="flex" alignItems="center" height="40px">
        <Typography fontWeight="500" fontSize="14px" color="--colorsUtilityYang080" m={0}>
          <FormattedMessage id="common.help" defaultMessage="Help" />
        </Typography>
      </Box>
      <a
        href={ZEN_DESK_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.option}
        onClick={handleHelpCentreMenuClick}
      >
        <FormattedMessage id="common.help_centre" defaultMessage="Help centre" />
      </a>
      <a className={styles.option} onClick={handleIntercomMenuClick}>
        <FormattedMessage id="common.ask_question" defaultMessage="Ask us a question" />
      </a>
      <div className={styles.divider} />
    </div>
  );
};
